export default "__VITE_ASSET__C$NDMl$e__"